import { useEffect, useState } from 'react';
import styles from '../AdminPortal.module.scss';
import { FancyButton } from '../../../components/primitives/FancyButton';
import { FlexIcon } from '../../../components/primitives/FlexIcon';
import { useUser } from '../../../app/hooks';
import { useNavigate } from 'react-router-dom';
import OrganizationViewStates from '../elements/OrganizationViewStates';
import OrganizationOverview from '../elements/OrganizationOverview';
import { VIEW_STATE_TERMS } from '../../../data/snapshot/dashboardStateSerialization';

type OrganizationSettingsTab = {
  id: 'overview' | 'viewStates';
  title: string;
  icon: string;
};

const organizationSettingsTabs: OrganizationSettingsTab[] = [
  { id: 'overview', title: 'Overview', icon: 'fad:sitemap' },
  { id: 'viewStates', title: VIEW_STATE_TERMS.titlePlural, icon: 'fas:layer-group' },
];

const OrganizationSettings = () => {
  const { user } = useUser();
  const navigate = useNavigate();

  // Active organization for the current user
  const organizationId = user.organizations.find((org) => org.isActive)?.organizationId;

  const [activeTab, setActiveTab] = useState<OrganizationSettingsTab>(organizationSettingsTabs[0]);

  useEffect(() => {
    if ((!user.isOrganizationAdmin && !user.isSystemAdmin) || !organizationId) {
      navigate('/');
      return;
    }
  }, [organizationId]);

  return (
    <>
      <div className={styles.adminHeaderWrapper}>
        {organizationSettingsTabs.map((tab) => (
          <div key={tab.id} style={{ display: 'inline-block', margin: '10px 30px' }}>
            <FancyButton iconName={tab.icon} large={true} onClick={() => setActiveTab(tab)}>
              {tab.title}
            </FancyButton>
          </div>
        ))}
      </div>
      <h1 className={styles.adminContentTitle}>
        <FlexIcon iconName={activeTab.icon} /> {activeTab.title}
      </h1>
      <div className={styles.adminContentWrapper}>
        {activeTab.id === 'viewStates' ? <OrganizationViewStates /> : <OrganizationOverview />}
      </div>
    </>
  );
};

export default OrganizationSettings;
